import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AppService } from '../../Services/app.service';

@Component({
  selector: 'app-management',
  templateUrl: './management.component.html'
})

export class ManagementComponent implements OnInit {

  title!: string;
  parentMenu: any;
  childMenu: any = '';
  currentMenu: any;
  navMenuName: any;

  breadcrumbConfig: object = {
    lastLinkColor: '#5B616E',
    symbol: ' / ',
  };

  constructor(
    private appService: AppService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.appService.currentChildMenuData.subscribe((ele) => {
      this.childMenu = ele;
    })
    this.appService.currentParentMenuData.subscribe((ele) => {
      this.parentMenu = ele;
    })
    this.appService.getTitle().subscribe((data) => {
      this.title = data;
      this.cdr.detectChanges();
    });
  }

  setParentMenu(event) {
    this.appService.chageParentMenuData(event);
    this.childMenu = '';
    this.title = '';
  }

  setChildMenu(event) {
    this.appService.chageChildMenuData(event);
    this.title = '';
  }
}
